<template>

  <div class="stock-slip-product">
     <b-row class="mb-5"
      > <b-col
        cols="2"
        class="pr-0"
        > <b-form-select
          class="select-style"
          v-model="productSearch.searchType"
          :options="optionProductSearchType"
          size="sm"
          value-field="id"
          text-field="name"
          :disabled="!storeId"
        ></b-form-select
        > </b-col
      > <b-col
        cols="8"
        class="pl-0"
        > <treeselect
          :load-options="loadOptionProducts"
          :multiple="false"
          :async="true"
          :placeholder="productSearch.placeHolder"
          :cache-options="false"
          retryText="Thử lại..."
          retryTitle="Nhấp thử lại"
          searchPromptText="Nhập để tìm kiếm..."
          loadingText="Đang tải..."
          noResultsText="Không có kết quả"
          openDirection="bottom"
          @select="onSelectProduct"
          :always-open="isOpenProductSearch"
          @search-change="onSearchChange"
          :disabled="!storeId || !editable"
          > <label
            slot="option-label"
            slot-scope="{ node, labelClassName }"
            :class="labelClassName"
            > <template
              >
              <div style="display: flex; align-items: center; gap: 8px">
                 <!-- Hình ảnh sản phẩm --> <ProductImage
                  :src="node.raw.productImageUrl"
                  style="width: 40px; height: 40px; object-fit: contain"
                /> <!-- Thông tin sản phẩm -->
                <div>
                   {{ node.raw.label }} <span
                    v-if="node.raw.imeiNo && node.raw.imeiNo.trim().length > 0"
                    class="text-warning"
                    > - IMEI: {{ node.raw.imeiNo }} </span
                  >
                </div>

              </div>
               </template
            > </label
          > </treeselect
        > </b-col
      > <b-col cols="2"
        >
        <div class="d-flex justify-content-end">
           <button
            class="btn btn-secondary font-weight-bolder btn-sm"
            @click="showModalImport"
            :disabled="!editable || !storeId"
          >
             <i
              style="font-size: 1rem"
              class="far fa-file-excel"
            ></i
            > Nhập từ excel </button
          >
        </div>
         </b-col
      > </b-row
    >
    <table class="table table-bordered table-hover">

      <thead>

        <tr>

          <th class="header-color text-center">STT</th>

          <th class="header-color text-center">Sản phẩm</th>

          <th
            scope="col"
            class="title-center"
          >
             IMEI
          </th>

          <th class="header-color text-center">Số lượng</th>

          <th class="header-color text-center">Đơn giá (sau VAT)</th>

          <th class="header-color text-center">VAT(%)</th>

          <th class="header-color text-center">Chiết khấu</th>

          <th class="header-color text-center">Thành tiền</th>

          <th v-if="editable"></th>

        </tr>

      </thead>

      <tbody
        v-for="(productItem, index) in productItems"
        :key="index"
      >

        <tr class="heighRow">

          <td
            class="text-center"
            style="width: 4%"
          >
             <span class="font-weight-bolder">{{ productItem.stt }}</span
            >
          </td>

          <td style="width: 24%"> <ProductCommonInfo :product="productItem" /> </td>

          <td
            class="px-4"
            style="width: 10%"
            ref="imeiTd"
          >

            <div v-if="editable && productItem.productType === productType.PRODUCT_IMEI">
               <ImeiInputModal
                :productItem="productItem"
                :storeId="storeId"
                :in-stock="inStock"
              />
            </div>

          </td>

          <td
            class="td-middle text-right"
            style="width: 8%"
          >

            <div v-if="editable">
               <BInputNumber
                v-if="editable"
                v-model="productItem.quantity"
                style="border-color: #007bff"
                placeholder="SL"
                :inputClass="'w-100 text-right'"
                :disabled="!editable || productItem.productType === productType.PRODUCT_IMEI"
              />
            </div>

            <div v-else> {{ productItem.quantity }} </div>

          </td>

          <td
            class="text-right align-middle"
            style="width: 14%; position: relative"
          >

            <div style="position: relative">
               <BInputNumber
                v-if="editable"
                v-model="productItem.afterVatPriceMask"
                placeholder="Đơn giá"
                style="border-color: #007bff"
                :inputClass="'w-100 text-right'"
                :disabled="!editable"
                @valueChange="onAfterVatPriceChange(productItem, $event)"
              />
              <div v-else> {{ convertPrice(getAfterVatPrice(productItem)) }} </div>
               <span
                v-if="fromWarranty && isUsingCostPrice(productItem)"
                class="small font-weight-bold text-warning d-block mt-1"
                > Lưu ý: đơn giá đang là giá vốn </span
              > <span
                v-if="productItem.vatAmount || productItem.afterVatPriceMask"
                class="text-muted small"
                style="
                  position: absolute;
                  top: 100%;
                  right: 0;
                  margin-top: 2px;
                  white-space: nowrap;
                  font-weight: 600;
                "
                > Đơn giá trước VAT:<br /> {{
                  formatBeforeVatPrice(getBeforeVatPrice(productItem))
                }} </span
              >
            </div>

          </td>

          <td
            class="td-middle text-right"
            style="width: 5%"
          >

            <div>

              <div>
                 <BInputNumber
                  v-if="editable"
                  v-model="productItem.vatAmount"
                  style="border-color: #007bff"
                  placeholder="VAT"
                  :inputClass="'w-100 text-right'"
                  :disabled="!editable"
                  @valueChange="onVatChange(productItem, $event)"
                />
                <div v-else> {{ convertPrice(productItem.vatAmount) }} </div>

              </div>

            </div>

          </td>

          <td
            class="td-middle text-right"
            style="width: 8%"
          >

            <div>

              <div v-if="editable">
                 <BInputNumber
                  v-model="productItem.discountAmount"
                  style="border-color: #007bff"
                  placeholder="Chiết khấu"
                  :inputClass="'w-100 text-right'"
                  :disabled="!editable"
                />
              </div>

              <div v-else> {{ convertPrice(productItem.discountAmount) || '' }} </div>
               <b-form-invalid-feedback :state="validateDiscountArr[productItem.id]"
                > {{ messageErrorDiscount }} </b-form-invalid-feedback
              >
            </div>

          </td>

          <td
            class="td-middle text-right"
            style="width: 10%"
          >
             <span> {{ convertPrice(getLineTotal(productItem)) }} </span
            >
          </td>

          <td
            class="td-middle"
            style="width: 5%"
            v-if="editable"
          >

            <div class="d-flex justify-content-center">
               <span
                style="color: #3f4254; font-size: 12px; cursor: pointer"
                @click="showDeleteAlert(productItem)"
                > <i
                  style="font-size: 1rem; color: #d33"
                  class="flaticon2-rubbish-bin-delete-button"
                ></i
                > </span
              >
            </div>

          </td>

        </tr>

      </tbody>

      <tfoot>

        <tr>

          <th
            style="text-align: end"
            colspan="3"
          >
             Tổng :
          </th>

          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
             {{ totalQuantity }}
          </td>

          <td></td>

          <td></td>

          <td></td>

          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
             {{ formattedTotalPrice }}
          </td>

        </tr>

      </tfoot>

    </table>
     <ImportStockSlipProductModal
      ref="importProductModal"
      :storeId="storeId"
      v-on:validData="validData"
    />
  </div>

</template>

<script>
  import {
    createDebouncedProductSearchExecutor,
    searchByImei,
    searchProducts,
    unwrapProductSearchData,
  } from '@/utils/productSearch'
  import _sumBy from 'lodash/sumBy'
  import Treeselect from '@riophae/vue-treeselect'
  import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import { PRODUCT_TYPE } from '@/utils/enum'
  import Swal from 'sweetalert2'
  import {
    makeToastFaile,
    cloneDeep,
    convertPrice,
    calculateAmountWithVAT,
    formatBeforeVatPrice,
    roundBeforeVatFromUnitPrice,
  } from '@/utils/common'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import ImeiInputModal from './ImeiInputModal.vue'
  import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
  import ImportStockSlipProductModal from './import-excels/ImportStockSlipProductModal.vue'

  const SEARCH_TYPE = {
    PRODUCT: 1,
    IMEI: 2,
    PRODUCT_SERVICE: 4,
  }

  export default {
    props: ['editable', 'productItems', 'storeId', 'inStock', 'fromWarranty'],
    data() {
      return {
        optionProductSearchType: [
          {
            id: 1,
            name: 'Tìm sản phẩm',
          },
          {
            id: 2,
            name: 'Tìm theo IMEI',
          },
          {
            id: 4,
            name: 'Tìm sản phẩm dịch vụ',
          },
        ],
        productSearch: {
          searchType: SEARCH_TYPE.PRODUCT,
          placeHolder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
          searchName: null,
        },
        isOpenProductSearch: false,
        productSearchTemp: null,
        messageErrorDiscount: 'CK vượt giá trị SP',
        validateDiscountArr: [],
        productType: PRODUCT_TYPE,
        imeiTdWidth: 0,
      }
    },
    components: {
      Treeselect,
      BInputNumber,
      ImeiInputModal,
      ProductImage,
      ProductCommonInfo,
      ImportStockSlipProductModal,
    },
    created() {
      this._productSearchLoader = createDebouncedProductSearchExecutor(
        async (searchQuery, options) => {
          const type = this.productSearch.searchType
          return this.searchProductAPI(searchQuery, type, options)
        },
      )
    },
    beforeDestroy() {
      this._productSearchLoader?.cancel?.()
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          const tdEl = this.$refs.imeiTd
          if (tdEl) {
            this.imeiTdWidth = tdEl[0].offsetWidth
          }
        }, 50)
      })
    },
    computed: {
      formattedTotalPrice() {
        const totalPrice = this.productItems.reduce(
          (sum, item) => sum + this.getLineTotal(item),
          0,
        )
        return convertPrice(totalPrice)
      },
      totalQuantity() {
        return _sumBy(this.productItems, 'quantity')
      },
    },
    methods: {
      convertPrice,
      calculateAmountWithVAT,
      formatBeforeVatPrice,
      getBeforeVatPrice(productItem) {
        if (!productItem) return 0
        if (productItem.beforeVatPrice != null && productItem.beforeVatPrice !== '') {
          return Number(productItem.beforeVatPrice) || 0
        }
        const afterVatPrice = Number(productItem.afterVatPriceMask)
        const vatAmount = Number(productItem.vatAmount) || 0
        if (afterVatPrice && vatAmount > 0) {
          return roundBeforeVatFromUnitPrice(afterVatPrice, vatAmount)
        }
        return Number(productItem.productPriceMask) || 0
      },
      getAfterVatPrice(productItem) {
        if (!productItem) return 0
        if (productItem.afterVatPriceMask != null) {
          return Number(productItem.afterVatPriceMask) || 0
        }
        return calculateAmountWithVAT(
          Number(productItem.productPriceMask) || 0,
          Number(productItem.vatAmount) || 0,
        )
      },
      getLineTotal(productItem) {
        if (!productItem) return 0
        return (
          this.getAfterVatPrice(productItem) * Number(productItem.quantity || 0) -
          Number(productItem.discountAmount || 0)
        )
      },
      syncAfterVatPrice(productItem) {
        if (!productItem) return
        productItem.afterVatPriceMask = calculateAmountWithVAT(
          Number(productItem.productPriceMask) || 0,
          Number(productItem.vatAmount) || 0,
        )
      },
      syncBeforeVatPrice(productItem) {
        if (!productItem) return
        const afterVatPrice = Number(productItem.afterVatPriceMask) || 0
        const vatAmount = Number(productItem.vatAmount) || 0
        const beforeVatPrice = roundBeforeVatFromUnitPrice(afterVatPrice, vatAmount)
        productItem.productPriceMask = beforeVatPrice
        productItem.beforeVatPrice = beforeVatPrice
      },
      onAfterVatPriceChange(productItem, value) {
        if (productItem) {
          productItem.afterVatPriceMask = Number(value || 0)
        }
        this.syncBeforeVatPrice(productItem)
      },
      onVatChange(productItem, value) {
        if (productItem) {
          productItem.vatAmount = Number(value || 0)
        }
        this.syncBeforeVatPrice(productItem)
      },
      isUsingCostPrice(productItem) {
        if (!productItem || productItem.originalPrice == null) return false
        const current = Number(productItem.productPriceMask) || 0
        const cost = Number(productItem.originalPrice) || 0
        return current === cost
      },
      loadOptionProducts({ action, searchQuery, callback }) {
        if (action !== ASYNC_SEARCH) return
        this.productSearchTemp = searchQuery
        this._productSearchLoader.run(searchQuery, (error, result) => {
          if (error) {
            callback(error, [])
            return
          }
          const type = this.productSearch.searchType
          const optionProduct = (result?.data || []).map((element) => {
            if (type === 1) {
              return {
                id: this.$uuid.v4(),
                label: element.productName,
                ...element,
              }
            }
            return {
              id: this.$uuid.v4(),
              label: element.productName,
              imeiNo: element.imeiNo,
              ...element,
            }
          })
          callback(null, optionProduct)
        })
      },
      onSearchChange(searchQuery) {
        if (searchQuery.length > 1 && !this.isOpenProductSearch) {
          this.isOpenProductSearch = true
        } else if (searchQuery.length === 0) {
          this.isOpenProductSearch = false
        }
      },
      async searchProductAPI(searchQuery, type, options = {}) {
        switch (type) {
          case SEARCH_TYPE.PRODUCT:
            return this.fetchProduct(searchQuery, undefined, options)
          case SEARCH_TYPE.IMEI:
            return this.fetchProductImei(searchQuery, options)
          case SEARCH_TYPE.PRODUCT_SERVICE:
            return this.fetchProduct(searchQuery, SEARCH_TYPE.PRODUCT_SERVICE, options)
          default:
            return { data: [] }
        }
      },
      async fetchProduct(textSearch, productType, options = {}) {
        this.listProduct = []
        const params = {
          searchText: textSearch,
          storeId: this.storeId,
          inStock: productType !== SEARCH_TYPE.PRODUCT_SERVICE ? this.inStock : false,
          productType: productType,
        }
        const response = await searchProducts(params, options)
        return { data: unwrapProductSearchData(response) }
      },
      async fetchProductImei(textSearch, options = {}) {
        this.listProduct = []
        if (!this.storeId) {
          makeToastFaile('Chưa chọn cửa hàng')
          return { data: [] }
        }
        const params = {
          searchText: textSearch,
          storeId: this.storeId,
        }
        const response = await searchByImei(params, options)
        return { data: unwrapProductSearchData(response) }
      },
      onSelectProduct(node) {
        this.isOpenProductSearch = false
        let countStt = this.productItems.length

        const item = this.handleProductItemSelected(node, ++countStt)
        this.productItems.push(item)
      },
      handleProductItemSelected(item, stt) {
        const itemSelected = cloneDeep(item)
        const productPrice = item.productPrice || item.sellingPrice || 0

        itemSelected.quantity = 1
        itemSelected.inStockQuantity = item.inStockQuantity
        itemSelected.productPrice = productPrice
        itemSelected.productPriceMask = productPrice
        itemSelected.afterVatPriceMask = productPrice
        itemSelected.stt = stt
        itemSelected.discountType = 1
        itemSelected.discountAmount = 0
        itemSelected.IMEI = item.imeiNo || ''
        itemSelected.vatAmount = 0

        // Nếu là bảo hành thì đơn giá là giá gốc
        if (this.fromWarranty) {
          itemSelected.productPriceMask = item.originalPrice
          itemSelected.afterVatPriceMask = item.originalPrice
        }
        return itemSelected
      },
      async showDeleteAlert(product) {
        const text = `Bạn muốn xoá sản phẩm ${product.productName} ra khỏi danh sách`
        const alert = await this.showWarningAlert(text)

        if (alert.isConfirmed) {
          const index = this.getIndexProductItems(product.id)

          if (index > -1) {
            this.productItems.splice(index, 1)
            this.numberedProductItems()
          }
        }
      },
      showWarningAlert: function (text) {
        return Swal.fire({
          title: 'Xoá sản phẩm!',
          text: text,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Đồng ý',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        })
      },
      getIndexProductItems(id) {
        const index = this.productItems.findIndex((item) => item.id === id)
        if (index < 0) {
          makeToastFaile(`Không tìm thấy ${id} trong danh sách`)
          throw new Error(`Không tìm thấy ${id} trong danh sách`)
        }
        return index
      },
      numberedProductItems() {
        let count = 1
        return this.productItems.map((item) => {
          item.stt = count
          count++
          return item
        })
      },
      renderImeis(productItem) {
        if (!productItem.IMEI) return []
        const listImei = productItem.IMEI.split(',')
        return listImei.map((imei, index) => ({
          no: index + 1,
          imeiCode: imei,
        }))
      },
      handleImeiClick(imeiCode) {
        const { href } = this.$router.resolve({
          name: 'list-imei-history',
          query: { code: imeiCode },
        })
        window.open(href, '_blank')
      },
      showModalImport() {
        this.$refs.importProductModal.showModal()
      },
      validData(data) {
        const currentIndex = this.productItems.length
        const stockSlipProducts = data.map((item, index) => {
          return {
            ...item,
            stt: index + currentIndex + 1,
            productPriceMask: item.unitPrice,
            afterVatPriceMask: calculateAmountWithVAT(
              Number(item.unitPrice) || 0,
              Number(item.vatAmount) || 0,
            ),
            IMEI: item.productImei || '',
          }
        })
        this.productItems.push(...stockSlipProducts)
      },
    },
    watch: {
      productItems: {
        handler(items) {
          ;(items || []).forEach((item) => {
            if (item.afterVatPriceMask == null) {
              this.syncAfterVatPrice(item)
            }
          })
        },
        immediate: true,
        deep: true,
      },
    },
  }
</script>

<style lang="css" scoped>
  .price-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center; /* căn ngang giữa input và số */
  justify-content: center; /* căn dọc giữa cả cụm */
  height: 100%; /* chiếm toàn bộ chiều cao ô */
}
.price-wrapper input {
  margin-bottom: 4px; /* khoảng cách giữa input và số */
}
.imei-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.imei-code {
  color: #007aff;
  text-decoration: underline;
  cursor: pointer;
}

.imei-code:hover {
  text-decoration: none;
  opacity: 0.8;
}
</style>

